import SweetScroll from 'sweet-scroll';
import jQuery from 'jquery';
import 'foundation-sites'

import {
  equalHeights, equalWidths, throttle
} from './functions';

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document);
      });
    }
  });
};

document.ready().then(function () {
  
  throttle('resize', 'optimized.resize');
  
  const cardsSections = document.getElementsByClassName('section--cards');
  const cardsSectionsCentered = document.getElementsByClassName('section--centeredIconCards');
  const cardsSectionsIconHeading = document.getElementsByClassName('section--iconHeadingTextBlocks');
  const cardsSectionsIconBenefits = document.getElementsByClassName('section--iconBenefitsCTA');
  
  
  const buttonGroups = document.getElementsByClassName('section__buttons');
  
  setTimeout(() => {
    // for(const cardsSection of cardsSections) {
    //   const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
    //   const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
    //   const images = cardsSection.querySelectorAll('.section__cardImage:not(.no-equalize)');
    //   const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
    //   equalHeights(headings);
    //   equalHeights(text);
    //   equalHeights(images);
    //   equalHeights(imageWrappers);
    // }
    
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  }, 300);
  
  window.addEventListener('optimized.resize', (event) => {
    for(const cardsSection of cardsSections) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      const images = cardsSection.querySelectorAll('.section__cardImage:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      equalHeights(images);
      equalHeights(imageWrappers);
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('optimized.resize', (event) => {
    for(const cardsSection of cardsSections) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      const images = cardsSection.querySelectorAll('.section__cardImage:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      equalHeights(images);
      equalHeights(imageWrappers);
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('optimized.resize', (event) => {
    for(const cardsSection of cardsSectionsIconBenefits) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      // const images = cardsSection.querySelectorAll('.section__cardIcon:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      // equalHeights(images);
      // equalHeights(imageWrappers);
      for(let image of imageWrappers){
        image.style.height = '75px';
      }
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('optimized.resize', (event) => {
    for(const cardsSection of cardsSectionsCentered) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      // const images = cardsSection.querySelectorAll('.section__cardIcon:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      // equalHeights(images);
      // equalHeights(imageWrappers);
      for(let image of imageWrappers){
        image.style.minHeight = '75px';
      }
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('optimized.resize', (event) => {
    for(const cardsSection of cardsSectionsIconHeading) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      // const images = cardsSection.querySelectorAll('.section__cardIcon:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      // equalHeights(images);
      // equalHeights(imageWrappers);
      for(let image of imageWrappers){
        image.style.height = '75px';
      }
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });

  window.addEventListener('load', (event) => {
    for(const cardsSection of cardsSections) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      const images = cardsSection.querySelectorAll('.section__cardImage:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      equalHeights(images);
      equalHeights(imageWrappers);
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('load', (event) => {
    for(const cardsSection of cardsSectionsCentered) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      // const images = cardsSection.querySelectorAll('.section__cardIcon:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      // equalHeights(images);
      // equalHeights(imageWrappers);
      for(let image of imageWrappers){
        image.style.minHeight = '75px';
      }
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('load', (event) => {
    for(const cardsSection of cardsSectionsIconBenefits) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      // const images = cardsSection.querySelectorAll('.section__cardIcon:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      // equalHeights(images);
      // equalHeights(imageWrappers);
      for(let image of imageWrappers){
        image.style.height = '75px';
      }
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  window.addEventListener('load', (event) => {
    for(const cardsSection of cardsSectionsIconHeading) {
      const headings = cardsSection.querySelectorAll('.section__cardHeadingsWrapper:not(.no-equalize)');
      const text = cardsSection.querySelectorAll('.section__cardText:not(.no-equalize)');
      // const images = cardsSection.querySelectorAll('.section__cardIcon:not(.no-equalize)');
      const imageWrappers = cardsSection.querySelectorAll('.section__cardImageWrapper:not(.no-equalize)');
      
      equalHeights(headings);
      equalHeights(text);
      // equalHeights(images);
      // equalHeights(imageWrappers);
      for(let image of imageWrappers){
        image.style.height = '75px';
      }
    }
    
    // for(const buttonGroup of buttonGroups) {
    //   const buttons = buttonGroup.getElementsByClassName('button');
    //   equalWidths(buttons, 15);
    // }
  });
  

  document.addEventListener('DOMContentLoaded', () => {

    const hash = window.location.hash;
    const needsInitialScroll = document.getElementById(hash.substr(1)) != null;

    if (needsInitialScroll) {
      window.location.hash = '';
    }

    // Handles scrolling to anchor on initial page load
    const scroller = new SweetScroll({
      duration: 1000,
      easing: 'easeOutQuint',
      updateURL: 'replace',
      header: '#site-header',
    });

    window.addEventListener('load', () => {
      if (needsInitialScroll) {
        scroller.to(hash);
      }
    }, false);

  }, false);

  const cards = document.getElementsByClassName('clickable-card');
  for(let card of cards) {
    card.style.cursor = "pointer"
    card.addEventListener('click', () => {
      // window.open(card.dataset.location);
      //window.location = card.dataset.location	
		if(e.dataset.target == "_blank"){
			window.open(e.dataset.location, '_blank')
		} else {
			window.location=e.dataset.location
		}
    })
  };

});


// When the user scrolls the page, execute myFunction
window.onscroll = function() {stickyNav()};

// Get the header
var header = document.getElementById("site-header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyNav() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky-header");
  } else {
    header.classList.remove("sticky-header");
  }
}


// let parallax = document.querySelectorAll('.parallax')

// if(parallax){
//   window.addEventListener("scroll", function() {
//     let offset = window.pageYOffset;
//     for(let i = 0; i < parallax.length; i ++){
//         parallax[i].style.backgroundPositionY = offset / 10 + 'px';
//     }
// })
// }


let searchInput = document.querySelector('.search-field');

// console.log('hello')
if(searchInput){
  // console.log('world')
  searchInput.placeholder = " ";
}



const shareLinkURLs = document.querySelectorAll('.share-link-url');
for(const link of shareLinkURLs) {
  link.addEventListener('click', event => {
    event.preventDefault();
    
    navigator.clipboard.writeText(link.href);
    alert("Link copied to clipboard: " + link.href);
  });
}


// Copy to clipboard
function copyLink() {
  /* Get the text field */
  var copyText = document.getElementById("link-share");

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /* For mobile devices */

  /* Copy the text inside the text field */
  document.execCommand("copy");

  /* Alert the copied text */
  alert("Link copied to clipboard: " + copyText.value);
}

let share = document.querySelector('.share-link');
if(share){
  share.addEventListener('click', () => {
    copyLink()
  })
}

// Nav - Add Search button icon
let searchForms = document.querySelectorAll('.site-header .search-form, .site-header__mobileMenu .search-form');
for(const searchForm of searchForms) {
  let newSearchButton = document.createElement('button');
  newSearchButton.type = 'submit';
  newSearchButton.value = 'Search';
  newSearchButton.innerHTML = '<i class="fas fa-search"></i>'
  searchForm.appendChild(newSearchButton);
  
  if(searchForm.closest('.site-header__mobileMenu')) {
    let search = searchForm.querySelector('.search-field');
    if(search) {
      search.setAttribute('placeholder', 'Search');
    }
  }
}



// Nav Menu Fix - arrow for submenu

// let listItem = document.querySelector('.service');
// let subMenu = document.querySelector('.service ul.sub-menu');

// var rect = listItem.getBoundingClientRect();
// var bodyRect = document.body.getBoundingClientRect();
// let offset = Math.round((bodyRect.left - rect.left) / window.innerWidth * 100);

// let classLeft = 'left-' + offset;

// subMenu.classList.add(classLeft);

// window.addEventListener("resize", function(){
//   subMenu.classList.remove(classLeft);
  
//   rect = listItem.getBoundingClientRect();
//   bodyRect = document.body.getBoundingClientRect();
//   offset = Math.round((bodyRect.left - rect.left) / window.innerWidth * 100);

//   classLeft = 'left-' + offset;

//   subMenu.classList.add(classLeft);
  
// });


// Custom global scripts
jQuery(document).ready(function ($) {
  'use strict';
  // Foundation Init
  $(document).foundation();
  
}(jQuery));

if(document.querySelector('.reveal__closeButton')) {
  document.querySelector('.reveal__closeButton').addEventListener('click', () => {
    document.querySelector('.reveal-overlay').style.display = 'none';
  })
}

// Iframes set height
let iframe = document.querySelector('.landing-form-container iframe')
let iframeContainer = document.querySelector('.form-height')
// console.log('iframe', iframeContainer, iframe)
if(iframeContainer) {
  iframe.style.height = iframeContainer.dataset.form + 'px'
}